import React, { useRef, useState, useEffect } from "react";
import { Button } from "@public/ui-toolkit";
import { logout } from "../../../allocator-portal/src/services/user";
import ReactInputVerificationCode from "react-input-verification-code";
import AuthLayout from "../AuthLayout";


const AccountVerification = ({ onSubmit, loginState, sendOTPToPhone, sendOTPToEmail }) => {
  const [code, setCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [hiddenEmail, setHiddenEmail] = useState("");

  const enterVerificationNumber = useRef(null);

  const onChangeVerificationCodeHandle = (e) => {
    setCode(e);
  };

  useEffect(() => {
    const atIndex = loginState?.emailAddress?.indexOf('@');

    if (atIndex !== -1) {
      const localPart = loginState?.emailAddress?.slice(0, atIndex);
      const domainPart = loginState?.emailAddress?.slice(atIndex);

      const hiddenLocalPart = localPart?.substring(0, 3) + '*'.repeat(5);
      const hiEmail = hiddenLocalPart + domainPart;
      setHiddenEmail(hiEmail)
    }
  }, []);

  const onSubmitCodedHandler = (e) => {
    e.preventDefault();
    var error = document.getElementById("error");
    if (code?.length === 6) {
      error.textContent = "";
      onSubmit(code);
    } else {
      error.textContent = "Please enter a valid number";
      error.style.color = "red";
    }
  };
  return (
    <div className="initial-screen-left-col">
      <div className="initial-screen-content">
        <h1 className="content-title">Enter Verification Code</h1>
        <p className="text-lightgrey text-mini mt-3 mb-0">
          Get a verification code
          {/* Verification code was sent to your
          {loginState?.phoneNumber !== null ? ` phone number ${loginState?.phoneNumber?.replace(/.{8}(.*)/, (_, rest) => '*****' + rest)} and ` : ""}
          email {hiddenEmail}. */}
        </p>
        <form onSubmit={onSubmitCodedHandler}>
          <div className="verification-code-container mt-md-5 mt-2">
            <ReactInputVerificationCode
              placeholder={false}
              onCompleted={onChangeVerificationCodeHandle}
              value={code}
              length={6}
              ref={enterVerificationNumber}
            />
          </div>
          <p id="error" className="mt-2"></p>

          <p className="mt-md-5 mt-2">
            Back to login
            <button
              onClick={logout}
              style={{ border: "none", background: "transparent" }}
            >
              <a href="/login">Login</a>
            </button>
          </p>
          <div className="mt-md-5 mt-2">
            {isCodeSent ?
              <Button
                btnName="Verify"
                btnType="primary"
                onClick={onSubmitCodedHandler}
                loading={loginState.loading}
              />
              : ""}
          </div>
        </form>
        <p className="mt-md-5 mt-2">{isCodeSent ? "Didn't get the code?" : ""}</p>
        <span>
        <Button
          btnName={<div>Get OTP on Email Address <br /> {hiddenEmail}</div>}
          btnType="primary"s
          onClick={() => {
            setIsCodeSent(true);
            sendOTPToEmail();
          }}
          loading={loginState.loadingEmail}
        />
        <Button
          btnName={<>Get OTP on Phone Number <br />{loginState?.phoneNumber?.replace(/.{9}(.*)/, (_, rest) => '*****' + rest)} </>}
          btnType="primary"
          disabled={loginState.phoneNumber ? false : true}
          onClick={() => {
            setIsCodeSent(true);
            sendOTPToPhone();
          }}
          loading={loginState.loadingPhone}
        />
        </span>
        {/* <p className="mt-md-5 mt-4"> */}
        {/* Didn't get the code?
          <button
            onClick={resendAction}
            style={{ border: "none", background: "transparent" }}
          >
            <u>Resend</u>
          </button> */}
        {/* </p> */}
      </div>
    </div>
  );
};

export default AuthLayout()(AccountVerification);
